import React from 'react'
import { PLL_IMAGES } from '../../../../Config/config'
import { AppExclusiveCon } from './styles'
import { Lk } from '../../../Links/Lk'

type ErrorProps = {
  questionLink: string
}

export const AppExclusive: React.FC<React.PropsWithChildren<ErrorProps>> = ({
  questionLink,
}) => {

  return (
    <AppExclusiveCon>
      <div className="infoCon">
        <div className="titleCon">
          <img src={PLL_IMAGES.pllAppLogo} alt="PLL app logo" />
          <h3 className="title">APP EXCLUSIVE</h3>
          <img src={PLL_IMAGES.pllAppLogo} alt="PLL app logo" />
        </div>
        <p>Download to participate & keep track of your choices.</p>
      </div>
      <Lk link={questionLink} alt="Open in PLL App">Open In App</Lk>
    </AppExclusiveCon>
  )
}
